import { Environment } from '@fitscovery/common/environments';

export const environment: Environment = {
  production: false,
  fitscoveryApps: {
    accountUrl: 'https://dev-account.fitscovery.com',
    adminUrl: 'https://dev-admin.fitscovery.com',
    fitscoveryUrl: 'https://dev.fitscovery.com',
    myDiscoveryUrl: 'https://dev-my.fitscovery.com',
    backofficeUrl: 'https://dev-backoffice-fitscovery.web.app',
    onboardingUrl: ''
  },
  apiKeys: {
    appInsights: '',
    googleMaps: 'AIzaSyDQUPOClCBqAJUmBd3-FkcG6tZJaHL_SoI',
    recaptchaKey: '6Lc_78YUAAAAAPJNHe4B-ZyvRY_ZWI76n0cW6VR9'
  },
  azureFunctionsApi: {
    auth: 'https://dev-api-auth-fitscovery.azurewebsites.net/api',
    events: 'https://dev-api-events-fitscovery.azurewebsites.net/api',
    partners: 'https://dev-api-partners-fitscovery.azurewebsites.net/api',
    memberships: 'https://dev-functions-memberships-fitscovery.azurewebsites.net/api',
    users: 'https://dev-api-users-fitscovery.azurewebsites.net/api',
    workouts: 'https://dev-api-workouts-fitscovery.azurewebsites.net/api',
    products: 'https://dev-functions-products-fitscovery.azurewebsites.net/api',
    payments: 'https://dev-functions-payments-fitscovery.azurewebsites.net/api',
    posts: 'https://dev-functions-posts-fitscovery.azurewebsites.net/api',
    bookings: 'https://dev-functions-bookings-fitscovery.azurewebsites.net/api'
  },
  azureFunctions: {
    images: {
      uploadUrl: 'https://devfitscoverypartnerimg1.blob.core.windows.net/for-image-compression',
      api: 'https://dev-functions-image-fitscovery.azurewebsites.net/api',
      functionsKey: 'zD47av/RJCeA7TxiLQyAN/aaRiUWrrBw3DL31XUI7jQE//7fDCFvVA=='
    }
  },
  nodeApi: {
    users: 'https://dev-api-users-sea.fitscovery.com/api'
  },
  cloudFunctionApi: 'https://asia-northeast1-mymvmnt-dev.cloudfunctions.net/api',
  paymentsApi: {
    paymongo: 'https://api.paymongo.com/v1',
    paymongoKey: 'pk_test_AqVzUhLdTX5iGV62EX79HofY'
  },
  xendItApi: {
    url: '',
    key: ''
  },
  firebase: {
    apiKey: 'AIzaSyAPSNihWzdt5mU8v7xibCQbo3dDICX4TZw',
    authDomain: 'mymvmnt-dev.firebaseapp.com',
    databaseURL: 'https://mymvmnt-dev.firebaseio.com',
    projectId: 'mymvmnt-dev',
    storageBucket: 'mymvmnt-dev.appspot.com',
    messagingSenderId: '498081428868',
    appId: '1:498081428868:web:4e6e27a6a268f50d55d9d1',
    measurementId: 'G-42D18VQ9CM'
  },
  facebook: {
    appId: '2122810874563822',
    clientToken: '77b6485fcc3b72797a4594ade7093fde'
  },
  version: '0.0.0'
};
